import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { ReloadOutlined } from '@ant-design/icons';
import { Table, Modal, Button, DatePicker, Select, Typography, Row, Col } from 'antd';
import _ from 'lodash';
import qs from 'qs';
import moment from 'moment';
import { isMobile } from 'react-device-detect';
import PageTitle from '../../components/PageTitle';
import TableActionBar from '../../components/TableActionBar';
import { checkPermission } from '../../utils/permission';
import { cleanObject } from '../../utils/helpers';
import {
    fetchScheduleShifts,
    removeScheduleShifts,
    createScheduleShifts,
    updateScheduleShift
} from '../../redux/actions/scheduleShiftActions';

const { Title } = Typography;
const { Option } = Select;
const { confirm } = Modal;
const days = [
    ['monday', 'Thứ 2', 1],
    ['tuesday', 'Thứ 3', 2],
    ['wednesday', 'Thứ 4', 3],
    ['thursday', 'Thứ 5', 4],
    ['friday', 'Thứ 6', 5],
    ['saturday', 'Thứ 7', 6],
    ['sunday', 'Chủ nhật', 0]
];

const routes = [
    { path: '/', breadcrumbName: 'Trang chủ' },
    { path: '/schedule-shifts', breadcrumbName: 'Ca làm việc' }
];

const EditableContext = React.createContext();
const EditableRow = ({ form, ...props }) => (
    <EditableContext.Provider value={form}><tr {...props} /></EditableContext.Provider>
);
const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends Component {
    state = { editing: false };

    save = () => {
        this.form.validateFields((error, values) => {
            if (error) return;
            this.setState({ editing: false });
            this.props.handleSave({
                ...this.props.record,
                [this.props.dataIndex]: values[this.props.dataIndex] || []
            });
        });
    };

    renderCell = form => {
        this.form = form;
        const { dataIndex, record, assignableUsers, text } = this.props;
        if (!this.state.editing) {
            return (
                <div className="editable-cell-value-wrap" onClick={() => this.setState({ editing: true })}>
                    {(text || []).map((value, index) => (
                        <p key={`${record.id}-${dataIndex}-${index}`} style={{ margin: 0, whiteSpace: 'nowrap' }}>{value}</p>
                    ))}
                </div>
            );
        }

        return (
            <Form.Item style={{ margin: 0 }} noStyle>
                {form.getFieldDecorator(dataIndex, { initialValue: record[dataIndex] || [] })(
                    <Select
                        mode="multiple"
                        className="w-100"
                        placeholder="Chọn nhân viên"
                        optionLabelProp="label"
                        allowClear
                        showSearch
                        autoFocus
                        onBlur={this.save}
                    >
                        {assignableUsers.map(item => (
                            <Option key={item.user_id} value={item.user_id} label={item.display_name}>
                                {item.display_name}
                            </Option>
                        ))}
                    </Select>
                )}
            </Form.Item>
        );
    };

    render() {
        const { editable, children } = this.props;
        const restProps = { ...this.props };
        ['editable', 'children', 'dataIndex', 'record', 'assignableUsers', 'handleSave', 'text']
            .forEach(key => delete restProps[key]);
        return (
            <td {...restProps}>
                {editable ? <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer> : children}
            </td>
        );
    }
}

class ScheduleShiftList extends Component {
    state = {
        isLoading: false,
        selectedRowKeys: [],
        isOpenForm: false,
        defaultStartDate: moment().startOf('isoWeek').format('YYYY-MM-DD'),
        defaultEndDate: moment().endOf('isoWeek').format('YYYY-MM-DD')
    };

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(previousProps) {
        if (previousProps.location.search !== this.props.location.search) this.loadData();
    }

    loadData = () => {
        const query = qs.parse(this.props.location.search.slice(1));
        this.setState({ isLoading: true });
        return this.props.fetchScheduleShifts(query)
            .catch(() => null)
            .finally(() => this.setState({ isLoading: false }));
    };

    changeWeek = value => {
        const query = { ...qs.parse(this.props.location.search.slice(1)) };
        if (value) {
            query.start_date = moment(value).startOf('isoWeek').format('YYYY-MM-DD');
            query.end_date = moment(value).endOf('isoWeek').format('YYYY-MM-DD');
        } else {
            delete query.start_date;
            delete query.end_date;
        }
        delete query.page;
        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(cleanObject(query))
        });
    };

    changeTable = (pagination, sorter) => {
        const query = { ...qs.parse(this.props.location.search.slice(1)) };
        if (!_.isEmpty(pagination)) {
            query.page = pagination.current;
            query.per_page = pagination.pageSize;
        }
        if (sorter.order) {
            query.sort_field = sorter.field;
            query.sort_type = sorter.order === 'ascend' ? 'ASC' : 'DESC';
        } else {
            delete query.sort_field;
            delete query.sort_type;
        }
        this.props.history.push({ pathname: this.props.location.pathname, search: qs.stringify(query) });
    };

    handleSave = row => {
        const currentRow = this.props.items.find(item => item.id === row.id);
        if (!currentRow) return;

        const changed = days.some(([day]) => JSON.stringify(row[day] || []) !== JSON.stringify(currentRow[day] || []));
        if (!changed) return;

        const data = {};
        days.forEach(([day]) => { data[day] = row[day] || []; });
        this.props.updateScheduleShift(row.id, data).then(this.loadData).catch(() => null);
    };

    remove = () => this.props.removeScheduleShifts(this.state.selectedRowKeys).then(() => {
        this.setState({ selectedRowKeys: [] });
        this.loadData();
    }).catch(() => null);

    confirmRemove = () => confirm({
        title: 'Cảnh báo',
        content: 'Bạn chắc chắn muốn xoá các dòng phân ca đã chọn?',
        okText: 'OK',
        cancelText: 'Huỷ',
        onOk: this.remove
    });

    create = event => {
        event.preventDefault();
        this.props.form.validateFields(['week'], (error, values) => {
            if (error) return;

            const startDate = moment(values.week).startOf('isoWeek').format('YYYY-MM-DD');
            const data = {
                scheduling_date: startDate,
                start_date: startDate,
                end_date: moment(values.week).endOf('isoWeek').format('YYYY-MM-DD')
            };
            confirm({
                title: 'Cảnh báo',
                content: 'Tạo lại lịch sẽ thay thế lịch đang hoạt động của tuần này và vẫn giữ lịch sử cũ. Tiếp tục?',
                okText: 'OK',
                cancelText: 'Huỷ',
                onOk: () => this.props.createScheduleShifts(data).then(() => {
                    this.closeForm();
                    this.changeWeek(values.week);
                })
            });
        });
    };

    closeForm = () => {
        this.props.form.resetFields(['week']);
        this.setState({ isOpenForm: false });
    };

    render() {
        const { items, pagination, config } = this.props;
        const { isLoading, selectedRowKeys, isOpenForm, defaultStartDate, defaultEndDate } = this.state;
        const query = qs.parse(this.props.location.search.slice(1));
        const assignableUsers = (config.doctors || []).filter(item => Number(item.is_active) === 1);
        const canUpdate = checkPermission('schedule_shifts', 'update');
        const columns = [
            {
                title: 'Khu vực làm việc', dataIndex: 'area_name', key: 'area_name', sorter: true,
                render: text => <strong>{text}</strong>
            },
            ...days.map(([day, label, dayOfWeek]) => ({
                title: label,
                dataIndex: day,
                key: day,
                width: 180,
                className: new Date().getDay() === dayOfWeek ? 'current-day-column' : '',
                onCell: record => ({
                    record,
                    editable: canUpdate,
                    dataIndex: day,
                    text: record[`${day}_user_name`],
                    assignableUsers,
                    handleSave: this.handleSave
                })
            }))
        ];
        const startDate = query.start_date || defaultStartDate;
        const endDate = query.end_date || defaultEndDate;

        return (
            <div>
                <PageTitle routes={routes} title="Ca làm việc" />
                <TableActionBar
                    isShowAddButton={checkPermission('schedule_shifts', 'create')}
                    isShowDeleteButton={checkPermission('schedule_shifts', 'remove')}
                    onAdd={() => this.setState({ isOpenForm: true })}
                    addText="Tạo lịch"
                    onDelete={this.confirmRemove}
                    disabled={!selectedRowKeys.length}
                    showFilter={false}
                    showSearch={false}
                    filters={[]}
                >
                    <DatePicker.WeekPicker
                        placeholder="Chọn tuần"
                        style={{ width: 200 }}
                        className="table-button"
                        onChange={this.changeWeek}
                        value={moment(startDate, 'YYYY-MM-DD')}
                    />
                    <Button className="table-button" icon={<ReloadOutlined />} loading={isLoading} onClick={this.loadData}>Làm mới</Button>
                    {selectedRowKeys.length ? <span>Đang chọn {selectedRowKeys.length} bản ghi</span> : null}
                </TableActionBar>
                <Table
                    rowKey="id"
                    size="small"
                    bordered
                    dataSource={items}
                    columns={columns}
                    loading={isLoading}
                    rowSelection={{ selectedRowKeys, onChange: keys => this.setState({ selectedRowKeys: keys }) }}
                    components={canUpdate ? { body: { row: EditableFormRow, cell: EditableCell } } : undefined}
                    rowClassName={() => 'editable-row'}
                    className="schedule-shift-list-table"
                    pagination={{
                        pageSize: pagination.perPage,
                        current: pagination.currentPage,
                        total: pagination.total,
                        showTotal: total => `Tổng ${total} bản ghi`
                    }}
                    onChange={(page, filters, sorter) => this.changeTable(page, sorter)}
                    scroll={{ x: 'max-content' }}
                    title={() => (
                        <Title level={4} style={{ margin: 0 }}>
                            Tuần {moment(startDate).isoWeek()} ({moment(startDate).format('DD/MM/YYYY')} - {moment(endDate).format('DD/MM/YYYY')})
                        </Title>
                    )}
                />
                <Modal
                    title="Tạo lịch"
                    visible={isOpenForm}
                    onCancel={this.closeForm}
                    maskClosable={false}
                    width={isMobile ? '100%' : '40%'}
                    footer={[
                        <Button key="cancel" onClick={this.closeForm}>Huỷ</Button>,
                        <Button key="submit" type="primary" onClick={this.create}>Tạo</Button>
                    ]}
                >
                    <Form layout="vertical">
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item label="Tuần">
                                    {this.props.form.getFieldDecorator('week', {
                                        rules: [{ required: true, message: 'Vui lòng chọn tuần.' }]
                                    })(
                                        <DatePicker.WeekPicker
                                            placeholder="Chọn tuần"
                                            className="w-100"
                                            disabledDate={current => current && current.endOf('isoWeek') < moment().startOf('isoWeek')}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    items: state.scheduleShiftReducer.items,
    pagination: state.scheduleShiftReducer.pagination,
    config: state.config
});

const mapDispatchToProps = dispatch => ({
    fetchScheduleShifts: filters => dispatch(fetchScheduleShifts(filters)),
    removeScheduleShifts: ids => dispatch(removeScheduleShifts(ids)),
    createScheduleShifts: data => dispatch(createScheduleShifts(data)),
    updateScheduleShift: (id, data) => dispatch(updateScheduleShift(id, data))
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'ScheduleShiftList' })(ScheduleShiftList));
